import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Observer } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as signalR from '@microsoft/signalr';

@Injectable({
  providedIn: 'root'
})
export class ChatsService {
  private chatRoomsSubject = new BehaviorSubject<any[]>([]);
  public chatRooms$ = this.chatRoomsSubject.asObservable();
   private unreadMessageSubject = new BehaviorSubject<boolean>(false);
  unreadMessage$ = this.unreadMessageSubject.asObservable();
  constructor() { }
  public hubConnection!: signalR.HubConnection;
  getAuthToken() {
    const obj:any = {
      token: localStorage.getItem('token'),
    };
    // Replace this with your actual code to retrieve the authentication token
    return obj.token;
  };

  ///app load start ///
  onLoadstartConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.chat}?userId=${environment.chatUserId}`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => {
          // Call the function to retrieve the token
          return this.getAuthToken();
        }
      })
      .withAutomaticReconnect()
      .withHubProtocol(new signalR.JsonHubProtocol())
      .build();

    this.hubConnection
      .start()
      .then(() => {
        console.log('Connection started');
        // Set up a listener for the 'ChatRooms' event to get chat data
        // Invoke 'AllChatRooms' method with a callback to handle the response
        this.hubConnection.on('Welcome', (message) => {
          console.log('Welcome message on Load Application :', message);
        });
      })
      .catch((err) => {
        console.error('Error while starting connection: ' + err);
      });
  }
startConnection() {
  this.hubConnection = new signalR.HubConnectionBuilder()
    .withUrl(`${environment.chat}?userId=${environment.chatUserId}`, {
      skipNegotiation: true,
      transport: signalR.HttpTransportType.WebSockets,
      accessTokenFactory: () => this.getAuthToken(),
    })
    .withAutomaticReconnect()
    .withHubProtocol(new signalR.JsonHubProtocol())
    .build();
  this.hubConnection.on('Welcome', (message: string) => {
    console.log('🟢 WebSocket Welcome:', message);
    this.getChatDataConnection();
    this.invokeAllChatRooms();
  });
   this.hubConnection.on('ReceiveMessage', (message: any) => {
      console.log('New message:', message);
      this.unreadMessageSubject.next(true);
    });
  this.hubConnection
    .start()
    .then(() => console.log('✅ SignalR connection started (waiting for Welcome...)'))
    .catch((err) => console.error('❌ Error starting connection:', err));
}
  clearUnread() {
    this.unreadMessageSubject.next(false);
  } 
public invokeAllChatRooms() {
  this.hubConnection
    .invoke('AllChatRooms',environment.chatUserId, 1, 50)
    .then(() => console.log('📩 AllChatRooms invoked successfully'))
    .catch((error) => console.error('❌ Error invoking AllChatRooms:', error));
}

  public resetChatRooms() {
   
    this.chatRoomsSubject.next([]); 
  }
  public getChatDataConnection() {
 this.hubConnection.on('ChatRooms', (response) => {
     this.chatRoomsSubject.next(response || []);
    });
  }


async chatDetailsConnection(chatRoomId: any) {
  if (!this.hubConnection || this.hubConnection.state !== signalR.HubConnectionState.Connected) {
    await this.ensureConnection();
  }
    this.getChatHistoryConnection();

  this.hubConnection.invoke('GetChatHistory', parseInt(chatRoomId), environment.chatUserId)
    .then(() => {
      console.log("GetChatHistory invoked successfully!");
    })
    .catch((error) => {
      console.error('Error invoking GetChatHistory:', error);
    });
}
async ensureConnection() {
  if (!this.hubConnection) {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${environment.chat}?userId=${environment.chatUserId}`, {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
        accessTokenFactory: () => this.getAuthToken()
      })
      .withAutomaticReconnect()
      .withHubProtocol(new signalR.JsonHubProtocol())
      .build();
  }
  if (this.hubConnection.state !== signalR.HubConnectionState.Connected) {
    try {
      await this.hubConnection.start();
    } catch (err) {
    }
  }
}
  getChatHistoryConnection() {
    return new Observable((observer: Observer<any>) => {
      this.hubConnection.on('ChatHistory', (response) => {
        observer.next(response); 
      });

    });
  }

  chatSendData(sender: any, receiver: any, message: any) {
        this.hubConnection
      .invoke('SendMessage', parseInt(sender), parseInt(receiver), message)
      .catch((error) => {
        console.error('Error invoking SendMessage:', error);
      });

  }

  receiveMessage() {
    return new Observable((observer: Observer<any>) => {
      this.hubConnection.on('ReceiveMessage', (response) => {
        console.log(response, 'data');
        observer.next(response);
      });
    });
  }
disconnect() {
  if (this.hubConnection) {
    this.hubConnection.stop()
      .then(() => console.log('SignalR disconnected successfully.'))
      .catch(err => console.error('Error while disconnecting SignalR:', err));
  }
}

}